import { NgStyle } from '@angular/common';
import { Component, OnInit, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogClose, MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { Icons } from '@shared/components/base-classes/base-group/constants';
import { environment } from 'src/environments/environment';
import { DigitDateDirective } from '../../../directives/digit-date.directive';
import { CustomButtonComponent } from '../../dxc-custom/custom-button/custom-button.component';
import { CustomCheckboxComponent } from '../../dxc-custom/custom-checkbox/custom-checkbox.component';
import { CustomDatePickerComponent } from '../../dxc-custom/custom-date-picker/custom-date-picker.component';

@Component({
    selector: 'app-dialog-message',
    templateUrl: './dialog-message.component.html',
    styleUrls: ['./dialog-message.component.scss'],
    imports: [CustomButtonComponent, NgStyle, CustomDatePickerComponent, DigitDateDirective, CustomCheckboxComponent, TranslateModule, MatDialogClose]
})
export class DialogMessageComponent implements OnInit {
  dialogRef = inject<MatDialogRef<DialogMessageComponent>>(MatDialogRef);
  data = inject(MAT_DIALOG_DATA);
  private router = inject(Router);
  private ativateRoute = inject(ActivatedRoute);
  private activatedRoute = inject(ActivatedRoute);
  RESOURCE_SERVER_URL = environment.RESOURCE_SERVER_URL;
  smileIcon = this.RESOURCE_SERVER_URL + '/assets/images/Misc/smiley.svg';
  tickIcon = Icons.tick;
  outputData: {};
  detail: any = {};

  ngOnInit(): void {
    this.detail = this.data;
  }

  onContinue() {
    this.dialogRef.close();
  }

  onSubmit() {
    this.dialogRef.close(true);
  }

  onCancel() {
    this.dialogRef.close(false);
  }
  onBillClose() {
    this.dialogRef.close();
  }

  onCloseInfo() {
    this.dialogRef.close();
    this.router.navigate(['/home']);
  }

  onCloseCreateClaimSuccess() {
    this.dialogRef.close();
    //this.router.navigate(['/claim/claim-registration']);
  }
  onCloseCreateSuccess() {
    this.dialogRef.close();
    this.router.navigate(['/home']);
  }
  onClosetpaSuccess() {
    this.dialogRef.close();
    this.router.navigate(['/claim/tpa-maintainence'], {
      relativeTo: this.activatedRoute,
    });
  }

  onCloseModifyClaimSuccess() {
    this.dialogRef.close();
    this.router.navigate(['/claim/claim-registration']);
  }

  onClose() {
    this.dialogRef.close();
  }

  btnOkContact() {
    this.dialogRef.close();
    this.router.navigate(['/contacts']);
  }

  btnSubmit() {
    this.dialogRef.close();
    this.router.navigate(['/home']);
  }

  onCloseClaimCreation() {
    this.dialogRef.close();
    if (sessionStorage.getItem('selected_role') == environment.role.GME) {
      this.router.navigate([`/claim/${localStorage.getItem('policyNoEM')}/claim-registration/${localStorage.getItem('memberNumberEM')}`]);
    } else {
      this.router.navigate(['/claim/claim-registration']);
    }
  }
  onCloseClaimDetail() {
    this.dialogRef.close();
    this.router.navigate(['/my-messages']);
  }

  onCloseProviderOrg() {
    this.dialogRef.close();
    this.router.navigate(['/claim/', localStorage.getItem('providerNetworkId'), 'provider-network-details'], {
      relativeTo: this.ativateRoute,
    });
  }

  onCloseProviderLink() {
    this.dialogRef.close();
    this.router.navigate([`../claim/${localStorage.getItem('providerId')}/provider-maintainence-details`]);
  }

  onCloseproviderOrgCreaModSuccess() {
    this.dialogRef.close();
    this.router.navigate(['claim/provider-maintenance']);
  }

  onCloseDrug() {
    this.dialogRef.close();
    this.router.navigate(['../..//procedure-drug-medicalsupplies/procedure-drug-dashboard'], {
      relativeTo: this.activatedRoute,
    });
  }

  oncloseAndNavigateOptions() {
    this.dialogRef.close();
    this.router.navigate([this.data.navigateTo]);
  }
  onCloseAddFeeSchedule() {
    this.dialogRef.close();
    this.router.navigate(['/claim/', localStorage.getItem('procedureIdFee'), 'fee-schedule'], {
      relativeTo: this.activatedRoute,
    });
  }

  onCloseSubmit() {
    this.dialogRef.close();
    !this.data.needNavigate && this.router.navigate(['/home']);
  }

  onChangeData(event, key) {
    this.outputData = { [key]: event };
    if (this.data.FlexibleContent?.typeField == 'checkbox') {
      this.data.FlexibleContent.valueField = event;
    }
  }

  onDataBlur(event, key) {
    this.outputData = { [key]: event };
    if (this.data.FlexibleContent?.typeField == 'checkbox') {
      this.data.FlexibleContent.valueField = event;
    }
  }

  onSubmitFlexibleData(haveDate?: any) {
    if (this.data.FlexibleContent?.typeField == 'datePicker') {
      if (this.outputData[haveDate] == null || this.outputData[haveDate] == '' || this.outputData[haveDate].length != 10) this.outputData[haveDate] = '';
      else {
        this.outputData[haveDate] =
          this.outputData[haveDate].substring(6, 10) + '-' + this.outputData[haveDate].substring(3, 5) + '-' + this.outputData[haveDate].substring(0, 2);
      }
    }
    this.dialogRef.close({
      isContinue: true,
      data: { ...this.outputData },
    });
  }
}
